import React, { useState, useEffect } from 'react';
import { Modal, Button, Checkbox, Message, Icon } from 'semantic-ui-react';
import { I18n, Translate } from 'react-redux-i18n';
import { IEventOrganizer } from '../../../models/EventOrganizer';

interface Props {
  isOpen: boolean;
  item: IEventOrganizer | null;
  isDeleting: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteEventOrganizerModal: React.FC<Props> = ({
  isOpen,
  item,
  isDeleting,
  error,
  onConfirm,
  onCancel,
}) => {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (isOpen) setAccepted(false);
  }, [isOpen, item?.id]);

  if (!item) return null;

  return (
    <Modal
      open={isOpen}
      onClose={isDeleting ? undefined : onCancel}
      closeOnDimmerClick={!isDeleting}
      closeOnEscape={!isDeleting}
      size='small'
    >
      <Modal.Header>
        <Icon name='warning sign' color='red' />
        <Translate value='eventOrganizers.page.delete.title' />
      </Modal.Header>
      <Modal.Content>
        <p>
          <strong>{item.name}</strong>
        </p>
        <Message negative>
          <Translate value='eventOrganizers.page.delete.warning' />
        </Message>
        <Checkbox
          label={I18n.t('eventOrganizers.page.delete.confirmCheckbox')}
          checked={accepted}
          onChange={(_, data) => setAccepted(!!data.checked)}
          disabled={isDeleting}
        />
        {error && (
          <Message negative style={{ marginTop: 12 }}>
            <p>{error}</p>
          </Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel} disabled={isDeleting}>
          <Translate value='eventOrganizers.page.delete.cancel' />
        </Button>
        <Button
          negative
          loading={isDeleting}
          disabled={!accepted || isDeleting}
          onClick={onConfirm}
        >
          <Icon name='trash' />
          <Translate value='eventOrganizers.page.delete.confirm' />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteEventOrganizerModal;
